import { useTranslation } from 'react-i18next'

import { IconButton, Tooltip } from '@mui/material'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'

import { Room } from '@/core/models/room.model'

import { LeaveEmergencyDialog } from './LeaveEmergencyDialog'
import { useLeaveEmergency } from '../model/useLeaveEmergency'

export function LeaveEmergencyButton({ emergencyRoom }: { emergencyRoom: Room }) {
  const { t } = useTranslation()
  const { leaveEmergency, openLeaveEmergencyDialog, setOpenLeaveEmergencyDialog } = useLeaveEmergency(emergencyRoom._id)
  return (
    <>
      <Tooltip title={t('page.emergency.leaveRoomButton.tooltip')}>
        <IconButton onClick={leaveEmergency}>
          <ExitToAppIcon htmlColor="#FFF" />
        </IconButton>
      </Tooltip>
      <LeaveEmergencyDialog open={openLeaveEmergencyDialog} onClose={() => setOpenLeaveEmergencyDialog(false)} emergencyRoom={emergencyRoom} />
    </>
  )
}
